// material
import { Box, BoxProps } from '@mui/material';

// ----------------------------------------------------------------------

export default function SeverErrorIllustration({ ...other }: BoxProps) {
  return <Box {...other} component="img" src={`/static/illustrations/illustration_500.svg`}></Box>;
}
